import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appInputDateMask]',
  standalone: true
})
export class InputDateMaskDirective {
  mask = [/\d/, /\d/, '.', /\d/, /\d/, '.', /\d/, /\d/, /\d/, /\d/];
  previousValue;

  constructor(private el: ElementRef) {
  }

  @HostListener('beforeinput', ['$event'])
  public onBeforeInput(event: InputEvent): void {
    const inputElement = this.el.nativeElement as HTMLInputElement;

    const currentValue = inputElement.value;
    const selectionStart = inputElement.selectionStart || 0;
    const selectionEnd = inputElement.selectionEnd || 0;

    const predictedValue = this.getPredictedValue(currentValue, event, selectionStart, selectionEnd);

    if (isDateValid(predictedValue)) {
      this.previousValue = predictedValue;
    } else {
      event.preventDefault();
    }
  }

  private getPredictedValue(
    currentValue: string,
    event: InputEvent,
    selectionStart: number,
    selectionEnd: number,
  ): string {
    const { inputType, data } = event;

    if (inputType === 'deleteContentBackward' || inputType === 'deleteContentForward') {
      return currentValue.slice(0, selectionStart) + currentValue.slice(selectionEnd);
    } else if (data) {
      return currentValue.slice(0, selectionStart) + data + currentValue.slice(selectionEnd);
    }
    return currentValue;
  }
}

const isDateValid = (text: string): boolean => {
  const regex = /^(\d{0,2}(\.\d{0,2})?(\.\d{0,4})?|(\.\d{0,2}(\.\d{0,4})?)|(\d{0,4}))$/;
  return regex.test(text);
};
